<script>
  import DropDown from '../components/DropDown.svelte';
  import ClientsDetailModal from '../components/clients/ClientsDetailModal.svelte';
  import GridSearch from '../components/GridSearch.svelte';
  import { masterData, getMasterData } from '../stores/masterData.js';
  import {
    dashboardData,
    getDashboardData,
    setDashboardData,
    resetDashboardData,
  } from '../stores/dashboard.js';
  import { onDestroy, onMount, getContext } from 'svelte';
  import { client } from 'root/api/index.js';
  import DataTable from '../components/DataTable/DataTable.svelte';
  import { navigate } from 'svelte-routing';
  import {
    configItem,
    downloadCsvFile,
    getHashUrlParam,
    cloneArray,
    searchKeyByValue,
    getValueBySearchValue,
  } from '../components/Helper';
  import Select from 'svelte-select';
  import { checkRole, getUserInfo } from '../stores/auth';
  import AssignTaskSubFilter from 'components/AssignTask/AssignTaskSubFilter.svelte';

  let clientDetailModal;

  const showDialog = getContext('showDialog');
  let units = [];
  let unitIds = {};
  let legacyCompanyType = [];
  let unitRegistrationType = [];
  let unitClientType = [];
  let showDeleteButton = false;
  let showImportButton = false;
  let allClientTypes = [];
  let allRegistrationTypes = [];
  let clientStatuses = [];
  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        units = cloneArray(getMasterData().units);
        unitIds = getMasterData().unitId;
        legacyCompanyType = getMasterData().legacyCompanyTypeLabel;
        unitRegistrationType = getMasterData().unitRegistrationType;
        unitClientType = getMasterData().unitClientType;
        allClientTypes = getMasterData().clientTypes;
        allRegistrationTypes = getMasterData().registrationTypes;

        let userRoleId = getUserInfo().roleId;
        let userRoles = getMasterData().userRoleId;
        clientStatuses = getMasterData().clientStatuses;
        showDeleteButton = userRoles.admin == userRoleId;
        showImportButton = userRoles.unit_admin == userRoleId || userRoles.admin == userRoleId;
      }
    });
  });

  const dashboardUnsubscribe = dashboardData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined && units) {
        units = units.map((item) => {
          item.checked = searchKeyByValue(state.units, 'id', item.id) != -1;
          return item;
        });

        if (units.filter((item) => item.checked).length > 0) {
          extraFilter = {
            ...extraFilter,
            units: units.filter((item) => item.checked),
          };
        }
        if (units.filter((item) => item.checked).length == 1) {
          getClientType();
        }
      }
    });
  });

  onDestroy(() => {
    unsubscribe();
    dashboardUnsubscribe();
  });

  let countMessage = '';

  let getCount = () => {
    let queries = {};
    client
      .clientCount({
        ...queries,
        ...extraFilter,
        comeFrom: 'countMessage',
      })
      .then((result) => {
        countMessage = result.data.countMessage;
      });
  };
  let getData = (queries) => {
    return client.clientList(50, 1, {
      ...queries,
      ...extraFilter,
    });
  };

  let datatableRef;
  let scrollRef;
  let columns = [
    { key: 'name', label: 'Name', sortable: true },
    {
      key: 'clientRegistrationType',
      label: 'Registration Type',
      sortable: true,
    },
    { key: 'clientType', label: 'Client Type', sortable: true },
    { key: 'unitName', label: 'Business Unit', sortable: true },
    { key: 'legacyCompanyType', label: 'Legacy Company', sortable: true },
    { key: 'clientStatusId', label: 'Status', sortable: true },
    { key: 'action', label: 'Action', sortable: false },
  ];

  let defaultFilter = {
    searchKeyword: '',
    userId: '',
    roleId: '',
    units: [],
    legacyCompanyType: '',
    clientTypes: [],
    registrationTypes: [],
    clientStatus: [],
    managerView: localStorage.getItem('client_manager_view') == 1 ? 1 : 0,
  };
  let isManagerChecked = defaultFilter.managerView == 1;
  let extraFilter = { ...defaultFilter };

  let searchTimeout;
  let firstTimeLoad = true;
  let filterData = () => {
    if (searchTimeout != undefined) {
      clearTimeout(searchTimeout);
    }
    searchTimeout = setTimeout(() => {
      if (datatableRef != undefined) {
        getCount();
        if (firstTimeLoad) {
          firstTimeLoad = false;
          return false;
        }
        datatableRef.initializeState();
      }
    }, 250);
  };

  const downloadCsv = () => {
    client
      .clientListExport({
        ...extraFilter,
      })
      .then(async (result) => {
        downloadCsvFile(result, 'clients.csv');
      });
  };
  const downloadCsvNew = () => {
    client
      .clientListExportLikeImport({
        ...extraFilter,
      })
      .then(async (result) => {
        downloadCsvFile(result, 'clients.csv');
      });
  };
  const downloadClientTransitionExport = () => {
    client
      .clientTransitionExport({
        ...extraFilter,
      })
      .then(async (result) => {
        downloadCsvFile(result, 'clients-transitions-export.csv');
      });
  };

  $: extraFilter && filterData();

  const checkUrl = () => {
    setTimeout(() => {
      let params = getHashUrlParam();
      if (params.action != undefined) {
        if (params.action == 'editClient') {
          navigate(`/client/edit/` + params.clientId);
        } else if (params.action == 'viewClient') {
          clientDetailModal.showModal({
            id: params.clientId,
            units,
            unitIds,
          });
        }
        window.location.hash = '';
      }
    }, 1000);
  };

  let allUsers = [];
  const getUsers = () => {
    client
      .unitUsers({
        units: [],
        inactiveCondition: 'N',
        inactiveUnitCondition: 'N',
      })
      .then((response) => {
        let detail = response.data;
        allUsers = detail.users.map((item) => {
          item.name = item.firstName + ' ' + item.lastName;
          return item;
        });
      });
  };

  onMount(() => {
    checkUrl();
    getUsers();
  });

  function showDelete(selectId) {
    showDialog({
      isDeleteModel: true,
      type: 'confirm',
      title: '',
      message: 'Are you sure?',
      okFunc: () => {
        client
          .clientDelete({ id: selectId })
          .then((response) => {
            filterData();
          })
          .catch((err) => {
            showDialog({ message: err.message });
          });
      },
    });
  }

  let clientType = [];
  let registrationType = [];
  let clientRegistrationTypeLoading = false;
  const getClientType = () => {
    clientRegistrationTypeLoading = false;
    if (extraFilter.units.length == 1) {
      let unitId = extraFilter.units[0].id;

      clientType = allClientTypes.filter((item) => {
        if (item.unit_id == unitId && item.active == 1) {
          item.subClientTypes = item.subClientTypes.filter((subItem) => {
            if (subItem.active == 1) {
              return subItem;
            }
          });
          return item;
        }
      });
      registrationType = allRegistrationTypes.filter((item) => {
        if (item.unit_id == unitId && item.active == 1) {
          item.subRegistrationTypes = item.subRegistrationTypes.filter((subItem) => {
            if (subItem.active == 1) {
              return subItem;
            }
          });
          return item;
        }
      });
      setTimeout(() => {
        clientRegistrationTypeLoading = true;
      }, 150);
    } else {
      clientType = clientType.filter((item) => {
        item.checked = false;
        return item;
      });
      registrationType = registrationType.filter((item) => {
        item.checked = false;
        return item;
      });
      extraFilter.clientTypes = [];
      extraFilter.registrationTypes = [];
    }
  };
</script>

<div class="d-flex h-100 w-100 p-3 flex-column">
  <div class="block-header mb-2">
    <div class="row align-items-center">
      <div class="col-md-7">
        <div class="d-flex flex-row align-items-center">
          <h2 class="page-title">
            Clients <span>{countMessage}</span>
          </h2>
          <div class="dropdown btn-drop-down me-3">
            <DropDown
              checkbox={true}
              active={true}
              title="Business Unit"
              labelFields="name"
              keyFields="id"
              option={units}
              Style="select-block font-size-13 w-100"
              checkedFields="checked"
              on:onSelect={(event) => {
                extraFilter = {
                  ...extraFilter,
                  units: event.detail,
                  clientStatus: [],
                };
                clientStatuses = clientStatuses.map((item) => {
                  item.checked = false;
                  return item;
                });
                setDashboardData({
                  ...getDashboardData(),
                  units: event.detail,
                  taskServiceType: [],
                  taskActivityTypes: [],
                });
                getClientType();
              }}
            />
          </div>
          {#if !checkRole(configItem.roleIndex.user)}
            <div class="d-flex flex-row align-items-center me-3">
              <label
                for=""
                class="text-nowrap mb-0 me-2">Manager View</label
              >
              <div class="form-check form-switch custom-switch">
                <input
                  style="width: 52px;height: 27px;margin-right: 10px;"
                  class="form-check-input shadow-none"
                  type="checkbox"
                  bind:checked={isManagerChecked}
                  on:change={(event) => {
                    extraFilter.managerView = isManagerChecked ? 1 : 0;
                    localStorage.setItem('client_manager_view', extraFilter.managerView);
                  }}
                />
              </div>
            </div>
          {/if}

          <div class="dropdown btn-add-client">
            <div class="btn-group dropdown-company">
              <button
                type="button"
                class="rounded background-blue text-white font-size-13 px-4 d-inline-block add-client-btn border-0 dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Add Client
              </button>
              <ul class="dropdown-menu">
                {#each units as item, key}
                  <li>
                    <button
                      on:click={() => {
                        navigate(`/client/add/${units[key].id}`);
                      }}
                      class="btn-link bg-transparent text-start color-black btn shadow-none border-0 btn-select-client font-size-12 px-1 py-1"
                    >
                      {item.name}
                    </button>
                  </li>
                  <li />{/each}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5 text-end">
        {#if showImportButton}
          <button
            on:click={() => navigate('/client/fund-import')}
            type="button"
            class="mb-0 px-3 font-size-13 btn btn-primary font-size-13 shadow-none px-3"
          >
            <img
              class="me-2 icon-16"
              src="./images/import-icon.svg"
              alt=""
            />Client Fund Import</button
          >
          <button
            on:click={() => navigate('/client/import')}
            type="button"
            class="mb-0 px-3 font-size-13 btn btn-primary font-size-13 shadow-none px-3"
          >
            <img
              class="me-2 icon-16"
              src="./images/import-icon.svg"
              alt=""
            />Client Import</button
          >
        {/if}
      </div>
    </div>
  </div>
  <div class="page-content card-content bg-white">
    <div class="d-flex flex-column h-100">
      <div class="filter-content top-menu-filter">
        <div class="d-flex flex-row justify-content-between">
          <div class="">
            <div class="d-flex flex-row">
              <!-- Default dropend button -->
              <div class="mx-1">
                <DropDown
                  defaultTitle="Select User"
                  title={extraFilter.userId != undefined &&
                  extraFilter.userId > 0 &&
                  searchKeyByValue(allUsers, 'userId', extraFilter.userId) != -1
                    ? allUsers[searchKeyByValue(allUsers, 'userId', extraFilter.userId)].name
                    : 'Select User'}
                  searchbox={true}
                  option={allUsers}
                  Style="select-block font-size-13 w-100 assign-task-dropdown"
                  titleChanged={true}
                  on:onSelect={(event) => {
                    extraFilter.userId = event.detail.userId;
                  }}
                />
              </div>
              <div class="mx-1">
                <div class="dropdown btn-drop-down">
                  <DropDown
                    title={extraFilter.legacyCompanyType == undefined ||
                    extraFilter.legacyCompanyType == ''
                      ? 'Legacy Company'
                      : legacyCompanyType[extraFilter.legacyCompanyType - 1].name}
                    titleChanged={true}
                    option={legacyCompanyType}
                    Style="select-block font-size-13 w-100"
                    on:onSelect={(event) => {
                      extraFilter.legacyCompanyType = event.detail.id;
                    }}
                  />
                </div>
              </div>
              {#if extraFilter.units.length == 1 && clientRegistrationTypeLoading}
                <AssignTaskSubFilter
                  comeFrom="client"
                  clientType={clientType}
                  registrationType={registrationType}
                  applyFilter={(params, openType) => {
                    if (openType == 'clientType') {
                      extraFilter.clientTypes = params.clientTypes;
                    } else {
                      extraFilter.registrationTypes = params.registrationTypes;
                    }
                  }}
                />
              {/if}
              {#if extraFilter.units.length == 1}
                <div class="mx-1">
                  <div class="dropdown btn-drop-down">
                    <DropDown
                      removeIcon={true}
                      checkedFields="checked"
                      checkbox={true}
                      active={true}
                      title="Status Filter"
                      option={clientStatuses.filter((item) => {
                        if (item.unit_id) {
                          if (extraFilter.units[0].id == item.unit_id) {
                            return true;
                          }
                          return false;
                        }
                        return true;
                      })}
                      Style="select-block ms-1"
                      selectable={true}
                      titleChanged={true}
                      on:onSelect={(event) => {
                        extraFilter.clientStatus = event.detail;
                      }}
                      on:onClear={(event) => {
                        extraFilter.clientStatus = [];
                      }}
                    />
                  </div>
                </div>
              {/if}

              <button
                type="button"
                class="p-0 reset-filter color-blue d-flex flex-row align-items-center text-start ms-1 bg-transparent border-0"
                on:click={() => {
                  isManagerChecked = false;
                  clientStatuses = clientStatuses.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  extraFilter = { ...defaultFilter };
                  setDashboardData({
                    ...getDashboardData(),
                    // units:[],
                  });
                }}
              >
                <img
                  class="icon-14 me-2"
                  alt=""
                  src="/images/reset.svg"
                />
                Reset Filter
              </button>
            </div>
          </div>
          <div class="d-flex right-action-btn">
            <GridSearch
              bind:value={extraFilter.searchKeyword}
              exportPrefix="Exports:"
              exportText="Basic"
              btnExport={true}
              isManagerView={checkRole(configItem.roleIndex.manager) ||
                checkRole(configItem.roleIndex.unit_admin)}
              placeholder="Search by Name"
              onAction={(params) => {
                if (params == 'export') {
                  downloadCsv();
                }
                if (params == 'delete') {
                  alert('delete');
                }
              }}
            />
            <button
              on:click={() => {
                downloadCsvNew();
              }}
              class="mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
            >
              <svg
                class="me-1 icon-16"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                style="enable-background:new 0 0 512 512;"
                xml:space="preserve"
                ><g
                  ><g
                    ><path
                      d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
                    /></g
                  ></g
                ><g
                  ><g
                    ><path
                      d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
                    /></g
                  ></g
                ></svg
              >Detailed</button
            >
            <button
              on:click={() => {
                downloadClientTransitionExport();
              }}
              class="mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
            >
              <svg
                class="me-1 icon-16"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                style="enable-background:new 0 0 512 512;"
                xml:space="preserve"
                ><g
                  ><g
                    ><path
                      d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
                    /></g
                  ></g
                ><g
                  ><g
                    ><path
                      d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
                    /></g
                  ></g
                ></svg
              >Client Transitions</button
            >
          </div>
        </div>
      </div>
      <div class="page-content card border-0 p-3">
        <div
          class="ibox-content page-content"
          bind:this={scrollRef}
        >
          <DataTable
            bind:this={datatableRef}
            columns={columns}
            scrollRef={scrollRef}
            getData={getData}
            let:row
          >
            <td width="200">
              <button
                type="button"
                class="btn btn-link text-start mb-0 shadow-none bg-transparent border-0 font-size-12 p-0 blue-color text-break"
                on:click={() => {
                  clientDetailModal.showModal({
                    id: row.id,
                    units,
                    unitIds,
                  });
                }}
              >
                <span class="user-name d-block">{row.name}</span>
              </button>
            </td>
            <td width="300"><span class=" text-break">{row.clientRegistrationType}</span></td>
            <td width="300"><span class=" text-break">{row.clientType}</span></td>
            <td width="300"><span class=" text-break">{row.unitName}</span></td>
            <td width="300"><span class=" text-break">{row.legacyCompanyType}</span></td>
            <td width="110">
              <DropDown
                searchbox={true}
                deleteSelected={false}
                checkbox={false}
                active={true}
                title={getValueBySearchValue(clientStatuses, 'id', row.clientStatusId, 'name', '')}
                option={clientStatuses.filter((item) => {
                  if (item.unit_id) {
                    if (
                      row.unitId == item.unit_id &&
                      (item.active == 1 || item.id == row.clientStatusId)
                    ) {
                      return true;
                    }
                    return false;
                  }
                  return true;
                })}
                Style="select-block ms-1 client-status-dropdown"
                selectable={true}
                titleChanged={true}
                on:onSelect={(event) => {
                  showDialog({
                    type: 'confirm',
                    title: '',
                    message: 'Are you sure ?',
                    okFunc: () => {
                      client
                        .clientUpdateStatusId({
                          id: row.id,
                          clientStatusId: event.detail.id,
                        })
                        .then((result) => {
                          datatableRef.changeData(
                            {
                              id: row.id,
                              clientStatusId: event.detail.id,
                            },
                            'id',
                          );
                        })
                        .catch((error) => {
                          datatableRef.changeData(
                            {
                              id: row.id,
                              clientStatusId: row.clientStatusId,
                            },
                            'id',
                          );
                          showDialog({
                            message: error.message,
                          });
                        });
                    },
                    cancelFunc: () => {
                      datatableRef.changeData(
                        {
                          id: row.id,
                          clientStatusId: row.clientStatusId,
                        },
                        'id',
                      );
                    },
                  });
                }}
              />
            </td>
            <td width="300">
              <button
                on:click={() => navigate(`/client/edit/${row.id}`)}
                class="btn bg-transparent shadow-none border-0 p-0 m-0 me-2 color-blue font-size-12"
              >
                <img
                  class="icon-16"
                  alt=""
                  src="/images/pencil-gray.svg"
                />
              </button>
              {#if showDeleteButton}
                <button
                  class="btn bg-transparent shadow-none border-0 p-0 m-0 me-2 color-blue font-size-12"
                  on:click={() => showDelete(row.id)}
                >
                  <img
                    class=" icon-16"
                    alt=""
                    src="/images/cancel.svg"
                  />
                </button>
              {/if}

              <button
                on:click={() => {
                  navigate(
                    `/redirect/task#action=viewTask&clientId=${row.id}&unitId=${row.unitId}`,
                  );
                }}
                class="btn bg-transparent shadow-none border-0 p-0 m-0 color-blue font-size-12"
              >
                <img
                  class="task-activity"
                  alt=""
                  src="/images/task_activity.svg"
                />
                View Tasks
              </button>

              <button
                on:click={() => {
                  navigate(
                    `/redirect/task#action=taskOutlook&clientId=${row.id}&unitId=${row.unitId}`,
                  );
                }}
                class="btn bg-transparent shadow-none border-0 p-0 m-0 color-blue font-size-12 ms-1"
              >
                <img
                  class="task-activity"
                  alt=""
                  src="/images/agenda.svg"
                />
                Task outlook
              </button>
            </td>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</div>

<ClientsDetailModal bind:this={clientDetailModal} />
